// import qs from 'qs'
import { withHeadersInstance } from './api-instance.js'
const baseUrl = process.env.VUE_APP_URL_API

export const GetOccupancyMap = async function(parameters) {
    try {
        const { locationPublicId } = parameters

        if (locationPublicId === undefined)
            return Promise.reject(
                new Error('Missing required  parameter: locationPublicId')
            )

        return await withHeadersInstance({
            method: 'get',
            url: `${baseUrl}/location/${locationPublicId}/occupancy-map`,
        })
    } catch (e) {
        console.error(e)
    }
}

export const GetLessonsMap = async function(parameters) {
    try {
        const { classgrade, date } = parameters
        if (classgrade === undefined)
            return Promise.reject(
                new Error('Missing required  parameter: classgrade')
            )
        return await withHeadersInstance({
            method: 'get',
            url: `${baseUrl}/lesson/${classgrade}/lesson-date/${date}`,
        })
    } catch (e) {
        console.error(e)
    }
}
